<template>
  <section
    id="stepFlowContainer"
    class="step-flow-container wf-section"
  >
    <div class="step-wrapper">
      <div
        v-for="(step, index) in steps"
        :id="`step${index + 1}`"
        :key="step.title"
        class="step"
        :class="{ passed: index <= activeStep, active: index === activeStep, last: index === steps.length - 1 }"
      >
        <div class="step-title">
          {{ step.title }}
        </div>
        <div class="step-description">
          {{ step.description }}
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

type HeaderStep = {
  title: string;
  description: string;
};

export default defineComponent({
  props: {
    activeStep: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array as () => Array<HeaderStep>,
      default: () => [],
    },
  },
});
</script>

<style lang="scss">
#stepFlowContainer {
  display: flex;
}

.step-wrapper {
  display: flex;
  width: 100%;
}

.step {
  flex: 1;
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(245, 245, 245, 1) 31%, rgba(241, 241, 241, 1) 100%);

  position: relative;
  display: block;
  overflow: visible;
  height: 100px;
  padding: 20px 20px 20px 40px;
  line-height: 20px;
  object-fit: fill;
}

.step-title {
  font-family: Roboto, sans-serif;
  color: #454ebd;
  font-size: 20px;
  line-height: 27px;
  font-weight: 700;
  text-transform: uppercase;
}

.step-description {
  padding-top: 5px;
  font-family: 'Montserrat', serif;
  font-weight: bold;
  color: #4e4e4e;
  font-size: 16px;
  line-height: 15px;
}

.step.active,
.step.passed {
  background: linear-gradient(90deg, #8a91e4 0%, #676fd6 72%, #454ebd 100%);
}

.step:after {
  content: ' ';
  position: absolute;
  left: 100%;
  border-left: 30px solid #f1f1f1;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  top: 0;
  z-index: 10;
}

.step.active:after,
.step.passed:after {
  border-left: 30px solid #454ebd;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
}

.step:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.step.last {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.step.last:after {
  content: none;
}

.step.active .step-title,
.step.active .step-description,
.step.passed .step-title,
.step.passed .step-description {
  color: #f5fbfd;
}

@media (max-width: 576px) {
  #stepFlowContainer {
    padding: 0;
  }

  .step {
    margin-left: 5px;
    margin-right: 35px;
    display: none;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .step.active {
    display: block;
  }

  .step.last {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .step.last:after {
    content: ' ';
  }

  .m-pt-10 {
    padding-top: 10px;
  }

  .m-mt-10 {
    margin-top: 10px;
  }
}
</style>
